/* eslint-disable */
import TermPage from '../../../components/pages/termPage'

const Disclamier = ({ className }) => {
   return (
      <TermPage className={className} currentKey="disclaimer" />
   )
}
export default Disclamier